import React from "react";
import classnames from "classnames";
import {
    colorClassForTaskEarned,
    statusTextForTaskEarned,
} from "utils/taskStatus";
import moment from "moment";
import { MINUTE_DECIMAL_PLACES } from "constants/util";

interface Props {
    task: sage.model.ITask;
}

const BalanceMinutesEarnedBodyPageRow: React.FC<Props> = ({ task }) => {
    const updatedAt = moment(new Date(task.created_at)).fromNow();
    return (
        <div className="list-group-item light-group-item-action">
            <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-1">Task performed {updatedAt}</h5>
                <span
                    className={classnames(
                        "badge badge-pill",
                        `badge-${colorClassForTaskEarned(task)}`
                    )}
                >
                    {statusTextForTaskEarned(task)}
                </span>
            </div>
            {task.counted_time === null ? (
                <p>
                    Still pending, your account will be credited when the job
                    completes.
                </p>
            ) : (
                <p>
                    Added {task.counted_time.toFixed(MINUTE_DECIMAL_PLACES)}{" "}
                    minutes to your account
                </p>
            )}
        </div>
    );
};

export default BalanceMinutesEarnedBodyPageRow;
